<template>
  <section class="l-content">
    <el-card>
      <el-form :inline="true" :model="condition">
        <el-form-item label="状态">
          <el-select v-model="condition.status" placeholder="选择状态" clearable style="width: 150px;">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="申诉中" :value="1"></el-option>
            <el-option label="申诉通过" :value="2"></el-option>
            <el-option label="申诉不通过" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-divider></el-divider>
    <el-card v-if="pageData">
      <l-table :option="tableOption" :data="pageData.list" :start-index="pageData.startIndex">
        <template slot="status" slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
        </template>
        <template slot="appeal_score" slot-scope="scope">
          <span v-if="scope.row.appeal_score !== null">{{ scope.row.appeal_score }}分</span>
          <span v-else>-</span>
        </template>
      </l-table>
      <l-pager :page="pageData" @change="getPageData"></l-pager>
    </el-card>

    <!-- 申诉详情弹窗 -->
    <el-dialog title="申诉详情" :visible.sync="detailDialog.visible" width="500px">
      <el-descriptions :column="1" border v-if="detailDialog.data">
        <el-descriptions-item label="任务ID">{{ detailDialog.data.appeal.task_id }}</el-descriptions-item>
        <el-descriptions-item label="工人姓名">{{ detailDialog.data.appeal.worker_name }}</el-descriptions-item>
        <el-descriptions-item label="申诉理由">{{ detailDialog.data.appeal.appeal_reason }}</el-descriptions-item>
        <el-descriptions-item label="申诉时间">{{ detailDialog.data.appeal.create_time }}</el-descriptions-item>
        <el-descriptions-item label="当前状态">
          <el-tag :type="getStatusType(detailDialog.data.appeal.status)">{{ getStatusText(detailDialog.data.appeal.status) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="申诉评分" v-if="detailDialog.data.appeal.appeal_score !== null">
          {{ detailDialog.data.appeal.appeal_score }}分
        </el-descriptions-item>
        <el-descriptions-item label="地点" v-if="detailDialog.data.task">{{ detailDialog.data.task.location_name }}</el-descriptions-item>
        <el-descriptions-item label="处理备注" v-if="detailDialog.data.appeal.handle_remark">{{ detailDialog.data.appeal.handle_remark }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="detailDialog.visible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 申诉处理弹窗 -->
    <el-dialog :title="handleDialog.title" :visible.sync="handleDialog.visible" width="500px">
      <el-form :model="handleForm" :rules="handleRules" ref="handleForm" label-width="100px">
        <el-form-item label="申诉评分" prop="score">
          <el-input-number v-model="handleForm.score" :min="0" :max="100" style="width: 100%"></el-input-number>
          <span style="color: #909399; font-size: 12px;">请输入0-100的判定评分</span>
        </el-form-item>
        <el-form-item label="处理备注" prop="remark">
          <el-input type="textarea" v-model="handleForm.remark" :rows="4" placeholder="请输入处理备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitHandle">确定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['userInfo'])
  },
  name: 'CleanAppealList',
  data() {
    return {
      tableOption: {
        stripe: true,
        height: document.documentElement.clientHeight - 280 + 'px',
        columns: [
          { label: '序号', type: 'index', width: 60 },
          { label: '任务ID', prop: 'task_id', width: 80 },
          { label: '工人姓名', prop: 'worker_name', width: 120 },
          { label: '申诉理由', prop: 'appeal_reason', minWidth: 200 },
          { label: '申诉时间', prop: 'create_time', width: 160 },
          { label: '状态', slot: 'status', width: 100 },
          { label: '申诉评分', slot: 'appeal_score', width: 100 },
          { label: '处理人', prop: 'handle_user_name', width: 100 },
          { label: '处理时间', prop: 'handle_time', width: 160 }
        ],
        operation: {
          width: '280',
          buttons: [
            { type: 'primary', icon: 'el-icon-view', label: '详情', click: this.viewDetail },
            { type: 'success', icon: 'el-icon-check', label: '通过', click: this.handlePass, disabled: row => row.status !== 1 },
            { type: 'danger', icon: 'el-icon-close', label: '不通过', click: this.handleReject, disabled: row => row.status !== 1 }
          ]
        }
      },
      condition: {
        status: 1,
        pageIndex: 1,
        pageSize: 15
      },
      pageData: null,
      detailDialog: {
        visible: false,
        data: null
      },
      handleDialog: {
        visible: false,
        title: ''
      },
      handleForm: {
        appealId: 0,
        result: 0,
        score: null,
        remark: ''
      },
      handleRules: {
        score: [
          { required: true, message: '请输入申诉评分', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '评分范围0-100', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
    getStatusType(status) {
      const map = {
        1: 'warning',
        2: 'success',
        3: 'danger'
      }
      return map[status] || 'info'
    },
    getStatusText(status) {
      const map = {
        1: '申诉中',
        2: '申诉通过',
        3: '申诉不通过'
      }
      return map[status] || '未知'
    },
    async getPageData(pageOption) {
      Object.assign(this.condition, pageOption)
      this.pageData = await this.$lgh.get('api/clean/appeal/list', {
        enterpriseCode: this.userInfo.enterpriseCode,
        status: this.condition.status,
        pageIndex: this.condition.pageIndex,
        pageSize: this.condition.pageSize
      })
    },
    async viewDetail(item) {
      const detail = await this.$lgh.get('api/clean/appeal/info', { appealId: item.appeal_id })
      if (!detail) return
      this.detailDialog.data = detail
      this.detailDialog.visible = true
    },
    handlePass(item) {
      this.openHandleDialog(item, 2, '申诉通过')
    },
    handleReject(item) {
      this.openHandleDialog(item, 3, '申诉不通过')
    },
    openHandleDialog(item, result, title) {
      this.handleDialog.title = title
      this.handleDialog.visible = true
      this.handleForm.appealId = item.appeal_id
      this.handleForm.result = result
      this.handleForm.score = null
      this.handleForm.remark = ''
      this.$nextTick(() => {
        this.$refs.handleForm.clearValidate()
      })
    },
    async submitHandle() {
      this.$refs.handleForm.validate(async (valid) => {
        if (!valid) return
        await this.$lgh.post('api/clean/appeal/handle', {
          appealId: this.handleForm.appealId,
          result: this.handleForm.result,
          score: this.handleForm.score,
          remark: this.handleForm.remark
        })
        this.handleDialog.visible = false
        this.$lgh.notifySuccess('处理成功')
        this.getPageData()
      })
    }
  }
}
</script>
